import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from 'routes'
import { reverse } from 'named-urls'

import helpers from 'helpers'

import { formatCpf, formatCnpj } from '@brazilian-utils/formatters'

import {
  Box,
  Button,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

import { makeStyles } from '@material-ui/core/styles'
import styles from './styles'

const useStyles = makeStyles(styles)

const ClientInfo = ({ customer }) => {
  const classes = useStyles()
  const clientId = customer && customer.id

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Dados do Pagador</Typography>
        {clientId ? (
          <Button
            variant="outlined"
            color="primary"
            component={Link}
            to={reverse(routes.clients.show, { clientId })}
          >
            Detalhar
          </Button>
        ) : null}
      </Box>
      <Divider />
      <Box className={classes.content}>
        <Paper className={classes.fullWidth}>
          <Box
            p={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h4">Cliente</Typography>
          </Box>
          <Divider />
          {customer ? (
            <Table>
              <TableBody>
                <TableRow hover>
                  <TableCell>Tipo</TableCell>
                  <TableCell>{helpers.people.kind(customer.kind)}</TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Nome</TableCell>
                  <TableCell>{customer.name}</TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Email</TableCell>
                  <TableCell>{customer.email}</TableCell>
                </TableRow>
                {helpers.people.isCompany(customer.kind) ? (
                  <TableRow hover>
                    <TableCell>CNPJ</TableCell>
                    <TableCell>{formatCnpj(customer.cnpj)}</TableCell>
                  </TableRow>
                ) : (
                  <TableRow hover>
                    <TableCell>CPF</TableCell>
                    <TableCell>{formatCpf(customer.cpf)}</TableCell>
                  </TableRow>
                )}
                <TableRow hover>
                  <TableCell>Telefone</TableCell>
                  <TableCell>
                    {helpers.people.parsePhoneApi(customer.contact)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : (
            <SkeletonRow />
          )}
        </Paper>

        <Paper className={classes.fullWidth}>
          <Box
            p={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h4">Endereço</Typography>
          </Box>
          <Divider />
          {customer && customer.address ? (
            <Table>
              <TableBody>
                <TableRow hover>
                  <TableCell>CEP</TableCell>
                  <TableCell>
                    {helpers.people.formatCep(customer.address.postalCode)}
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Cidade</TableCell>
                  <TableCell>
                    {`${customer.address.city}/${customer.address.state}`}
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Bairro</TableCell>
                  <TableCell>{customer.address.neighborhood}</TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Rua</TableCell>
                  <TableCell>{customer.address.street}</TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Número</TableCell>
                  <TableCell>{customer.address.number}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : (
            <AddressSkeleton />
          )}
        </Paper>
      </Box>
    </Paper>
  )
}

const SkeletonRow = () => (
  <Table>
    <TableBody>
      <TableRow>
        <TableCell>Tipo</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Nome</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Email</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Documento</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Telefone</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
)

const AddressSkeleton = () => (
  <Table>
    <TableBody>
      <TableRow>
        <TableCell>CEP</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Cidade</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Bairro</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Rua</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>Número</TableCell>
        <TableCell>
          <Skeleton variant="rect" width="100%"></Skeleton>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
)

export default ClientInfo
